import Link from "next/link";
import { useTranslation } from "next-i18next";
import SmallCardThumbnail from "components/customImages/SmallCardThumbnail";
import { categoryTranslateKey, getCategoryStats } from "../../helpers/constants/translate";
import { FaFacebook } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import SocialMediaStats from "./socialMediaStats";

const Card = ({ id, category, title, image }) => {
  const { t: translate } = useTranslation("categories_carousel");
  const { t: categoriesTranslate } = useTranslation("categories");
  const stats = getCategoryStats(category);

  return (
    <Link href={`/categories/${category}`} passHref legacyBehavior>
      <div
        id={id}
        className="flex flex-col snap-start lg:snap-center lg:shrink-0 snap-always carouselItem cursor-pointer lg:w-[20%]"
      >
        <div>
          <div className="flex justify-center  pb-0 max-h-56 w-auto lg:w-full h-auto text-center hero-card">
            <SmallCardThumbnail
              key={image?.name}
              imageName={image?.name}
              alt={title}
              className="w-full rounded-t-2xl"
            />
          </div>

          <div className="flex justify-center text-center rounded-2xl h-72 bg-white pb-5 w-64 lg:w-full mt-[-140px]">
            <figcaption className="self-end text-blue">
              <p className="text-2xl font-bold text-blue">
                {categoriesTranslate(categoryTranslateKey(category))}
              </p>
              <p className="text-sm text-gray-400 flex flex-row justify-center gap-1 rtl:flex-row-reverse">
                <span>+{(stats?.fb || 0) + (stats?.instagram || 0)}</span>
                <span>{translate("pages")}</span>
              </p>
              <p className="pb-2"></p>
              <SocialMediaStats category={category} />
            </figcaption>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Card;
